import { createTheme } from "@mui/material";
import "../App.css"; 



export const appTheme = createTheme({
    palette: {
        primary: {
            main: 'rgb(0, 139, 176)'
        },
        secondary: {
            main: 'rgb(255, 255, 255)'
        }
    }
})
